module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Pokaż pasek filtrowania"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.show_filter_bar),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_filter_bar", $$v)
      },
      expression: "form.show_filter_bar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sections"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.sections), function(section, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": section.title_pl || 'Nowa sekcja',
        "items": _vm.form.sections,
        "errors": _vm.checkForErrors(_vm.errors.sections, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "sections", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i][_vm.addLanguageSuffix('title')]
      }
    }, [_c('el-input', {
      model: {
        value: (section[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(section, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "section[addLanguageSuffix('title')]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Galerie (kolejność względem dodawania)",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['galleries']
      }
    }, [_c('el-select', {
      attrs: {
        "multiple": "",
        "placeholder": "Wybierz galerie"
      },
      model: {
        value: (section.galleries),
        callback: function($$v) {
          _vm.$set(section, "galleries", $$v)
        },
        expression: "section.galleries"
      }
    }, _vm._l((_vm.groupedGalleries), function(group) {
      return _c('el-option-group', {
        key: group.label,
        attrs: {
          "label": group.label
        }
      }, _vm._l((group.options), function(item) {
        return _c('el-option', {
          key: item.id,
          attrs: {
            "label": item.name_pl,
            "value": item.id
          }
        })
      }), 1)
    }), 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("+ sekcja")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f753488"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/GalleriesListWidget.vue
// module id = 765
// module chunks = 0